var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:('width: 100%; height: ' + _vm.mapdata.height),attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }